import { Grid, Typography } from '@mui/material';
import { Box } from '@mui/system';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import {
  IStyles,
  pxToRem,
  pxTovW,
  resourceTypeName,
} from '@geneo2-web/shared-ui';
import { ProjectSelectableChapter } from '@protos/learning_management/lms.assessment.teacher.apis_pb';
import { useState } from 'react';
import { useAppDispatch } from 'apps/teacher/src/reduxStore/reduxHooks';
import { LessonPlanSelectionCard } from './LessonPlanSelectionCard';
import { setToastInfo } from '../../Home/reducer/homeDashboard.slice';
import { EditWarningPopup } from 'apps/teacher/src/components/EditWarningPopup';
import {
  clearProjectSelection,
  ISelectedProjectResource,
} from '../CreateProject/reducer/projectFlow.Slice';
import {
  getChapterResourceCount,
  resolveSelectedResources,
} from '../CreateProject/projectSelection.utils';
import { ProjectContentCard } from './ProjectContentCard';

const styles: IStyles = {
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
};
interface IProps {
  addMoreHandler: () => void;
  selectedChapter: ProjectSelectableChapter;
  selectedResources: ISelectedProjectResource[];
}
export const LessonPlanSelection = (props: IProps) => {
  const { addMoreHandler, selectedChapter, selectedResources } = props;

  const dispatch = useAppDispatch();
  const [openDeletePopup, setOpenDeletePopup] = useState(false);

  const resolvedResources = resolveSelectedResources(
    selectedChapter,
    selectedResources
  );

  return (
    <Box sx={styles.root}>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          mt: { xs: pxToRem(32), md: pxToRem(18), lg: pxTovW(20) },
        }}
      >
        <Typography variant="h2" sx={{ marginY: 'auto' }}>
          Your Added Project
        </Typography>
        <Box
          sx={{
            backgroundColor: 'transparent',
            background: '#C1F8DA',
            display: 'flex',
            borderRadius: { xs: pxToRem(6), md: pxToRem(10), lg: pxTovW(10) },
            boxSizing: 'border-box',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
            border: '1px solid #0AA34F',
            padding: {
              xs: pxToRem(7),
              md: `${pxTovW(16)} ${pxTovW(23)}`,
              lg: `${pxTovW(13)} ${pxTovW(25)}`,
            },
            gap: { xs: pxToRem(5), md: pxToRem(16), lg: pxTovW(16) },
            height: { xs: pxToRem(32), md: pxToRem(41), lg: pxTovW(57) },
          }}
          onClick={addMoreHandler}
        >
          <AddCircleIcon
            sx={{
              color: '#03612D',
              fontSize: { xs: pxToRem(18), md: pxToRem(25), lg: pxTovW(31) },
            }}
          />
          <Typography variant="h3" fontWeight="bold" sx={{ color: '#0AA34F' }}>
            Update
          </Typography>
        </Box>
      </Box>
      <Box sx={{ mt: { xs: pxToRem(12), md: pxToRem(18), lg: pxTovW(20) }, width: '100%' }}>
        <Grid
          container
          columns={12}
          rowGap={3}
          sx={{ padding: 0, width: '100%' }}
        >
          <Grid item xs={12} md={6} lg={4}>
            <Box
              sx={{
                boxSizing: 'border-box',
                width: '100%',
                paddingX: { xs: pxToRem(10), md: pxToRem(10), lg: pxTovW(10) },
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <LessonPlanSelectionCard
                title={
                  selectedChapter.chapterNo
                    ? `${selectedChapter.chapterNo}.${selectedChapter.chapterName ?? ''}`
                    : selectedChapter.chapterName
                }
                posterImageUrl={selectedChapter.posterImageUrl}
                totalResourceCount={getChapterResourceCount(selectedChapter)}
                selectedCount={selectedResources.length}
                deleteHandler={() => setOpenDeletePopup(true)}
                variant="medium"
              />
            </Box>
          </Grid>
        </Grid>
      </Box>

      <EditWarningPopup
        open={openDeletePopup}
        handleClose={() => setOpenDeletePopup(false)}
        yesClickHandler={async () => {
          dispatch(clearProjectSelection());
          setOpenDeletePopup(false);
          dispatch(
            setToastInfo({
              label: `${
                selectedChapter.chapterName ?? 'Chapter'
              } deleted successfully`,
              variant: 'info',
              open: true,
            })
          );
        }}
        noClickHandler={async () => {
          setOpenDeletePopup(false);
        }}
        iconname="delete"
        text1={`Are you sure to you want to delete ${
          selectedChapter.chapterName ?? 'this chapter'
        } ?`}
        text2=""
      />
    </Box>
  );
};
